export function isgValidatorNumberRequired(value: any, callback: (value: boolean) => void) {

  if (value === null || value === undefined || value.toString().trim() === '') {
    callback(false);
    return;
  }

  // Convert to string and trim
  const stringValue = value.toString().trim();

  // Remove all thousand separators (both comma and period)
  // Then replace the remaining decimal separator (if any) with a period
  // This handles both US format (1,234.56) and European format (1.234,56)
  const normalizedValue = stringValue
    .replace(/[,.\s]/g, function (match: string) {
      // Keep the last instance of comma or period as decimal separator
      if ((match === ',' || match === '.') &&
        stringValue.lastIndexOf(match) === stringValue.indexOf(match)) {
        return '.';
      }
      return '';
    });

  // Check if it's a valid number
  const isValid = !isNaN(parseFloat(normalizedValue)) && isFinite(Number(normalizedValue));

  callback(isValid);
}
